var r={exports:{}};export{r as l};
//# sourceMappingURL=localeData.js.map
